import React, { useState } from "react";
import styles from "./ContactForm.module.css";
import { Field, Formik, Form } from "formik";
import {
  Button,
  InputGroup,
  Form as BootstrapForm,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import * as Yup from "yup";
import countryList from "../../constant/country";
import { contactSubmit } from "../../actions/contact.action";
import { connect } from "react-redux";

const ContactForm = ({ contactSubmit }) => {
  const [submitting, setSubmitting] = useState(false);
  const onSubmitHandeler = async (values) => {
    setSubmitting(true);
    // TODO ::: create account action
    let check = contactSubmit(values);
    if (check === true) {
      //toast.success("Login Successful");
      setSubmitting(false);
    }
    setSubmitting(false);
  };
  let initVals = {
    name: "",
    email: "",
    company: "",
    country: "Bangladesh",
    message: "",
  };

  const SignupSchema = Yup.object().shape({
    email: Yup.string()
      .email("Enter valid email address")
      .required("Email is required!"),
    name: Yup.string().required("Name is required!"),
    country: Yup.string().required("Country is required!"),
    company: Yup.string().notRequired(),
    message: Yup.string().required("Message is required!"),
  });
  return (
    <div className={styles.wrapper}>
      <Formik
        initialValues={initVals}
        validationSchema={SignupSchema}
        onSubmit={(values) => onSubmitHandeler(values)}
      >
        {({ errors, touched }) => (
          <Form>
            <Container className="p-md-5 p-3">
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="name" className="d-block">
                        Your name
                      </label>
                      {errors.name && touched.name ? (
                        <small className="text-danger">{errors.name}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your name..."
                      name="name"
                      type="text"
                      className={`${styles.input} w-100`}
                    />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="email" className="d-block">
                        Contact Email
                      </label>
                      {errors.email && touched.email ? (
                        <small className="text-danger">{errors.email}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your email address..."
                      name="email"
                      isValid={!errors.email && touched.email}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.email && touched.email}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="company" className="d-block">
                        Company name
                      </label>
                      {errors.company && touched.company ? (
                        <small className="text-danger">{errors.company}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your company name..."
                      name="company"
                      isValid={!errors.company && touched.company}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.company && touched.company}
                    />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="country" className="d-block">
                        Country
                      </label>
                      {errors.country && touched.country ? (
                        <small className="text-danger">{errors.country}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Select}
                      placeholder="Type your country address..."
                      name="country"
                      isValid={!errors.country && touched.country}
                      className={`${styles.input} w-100`}
                      isInvalid={errors.country && touched.country}
                    >
                      {countryList.map((item, i) => (
                        <option key={i} value={item}>
                          {item}
                        </option>
                      ))}
                    </Field>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="message" className="d-block">
                        Your Message
                      </label>
                      {errors.message && touched.message ? (
                        <small className="text-danger">{errors.message}</small>
                      ) : null}
                    </div>
                    <Field
                      as={"textarea"}
                      placeholder="Type your message name..."
                      name="message"
                      isValid={!errors.message && touched.message}
                      type="text"
                      rows={6}
                      className={`${styles.input} form-control w-100`}
                      isInvalid={errors.message && touched.message}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="pt-3 d-flex justify-content-center align-items-center">
                  <Button
                    type="submit"
                    className={`.btn_primary ${styles.btn}`}
                    disabled={submitting}
                  >
                    {submitting ? "Submitting..." : "Contact Sales"}
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default connect(null, { contactSubmit })(ContactForm);
